module.exports = __webpack_public_path__ + "1da84b5578482c7a7f52acd786cae7.png";